import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'components/Carousel';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import Link from 'components/Link';
import Card from 'components_v2/common/CardV2/Card';
import s from './MostAnalytics.scss';

function MostAnalytics(props) {
  const { data, isWapView, userData } = props;
  const gaTitle = data?.name?.replace(' ', '');
  const isLoggedIn =
    userData && userData.isLoggedIn ? userData.isLoggedIn : false;
  const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
  const gaEvent = name => {
    if (typeof window !== 'undefined') {
      analyticsWrapper(
        'ga',
        'send',
        'event',
        'TOI Plus',
        `TOIPlus_HomePage_${name}_MoreStory_click`,
        `Ps-${!isLoggedIn && prcValue === 0 ? -1 : prcValue}`,
      );
    }
  };
  return !isWapView ? (
    data && (
      <div className={s.sliderBlock}>
        <div className="contentwrapper">
          <h3 className={s.mostAnalytics}>{data.name}</h3>
          <div className={s.col}>
            <Carousel slidesToScroll={3} slidesToShow={3}>
              {Array.isArray(data?.items) &&
                data.items?.length > 0 &&
                data.items?.map(item => (
                  <Card
                    data={item}
                    showDescription
                    isVerticalTile
                    timeStampHtml
                    imgWidth="280"
                    istoipListing
                    isVertical
                    isHomeListing
                    isMostAnalytics
                    userData={userData}
                    gaPageName={`TOIPlus_HomePage_${gaTitle}`}
                    tpPageName="toiphome"
                  />
                ))}
              <div className={s.readMore} onClick={() => gaEvent(gaTitle)}>
                <Link
                  className={s.readMoreLink}
                  to={data.path}
                  // onClick={onWidgetClick(`TOIPlus_InlineWidgets|Morestories`)}
                >
                  <span className={s.readMoreLinkText}>More stories</span>
                </Link>
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    )
  ) : (
    <div className={s.sliderBlock}>
      <h3 className={s.mostAnalytics}>{data.name}</h3>
      <div className={s.col}>
        {Array.isArray(data?.items) &&
          data.items?.length > 0 &&
          data.items?.map(item => (
            <Card
              data={item}
              showDescription
              isVerticalTile
              timeStampHtml
              imgWidth="228"
              istoipListing
              isVertical
              isHomeListing
              isMostAnalytics
              userData={userData}
              gaPageName={`TOIPlus_HomePage_${gaTitle}`}
              tpPageName="toiphome"
            />
          ))}
        <div className={s.readMore} onClick={() => gaEvent(gaTitle)}>
          <Link to={data.path} className={s.readMoreLink}>
            <span className={s.readMoreLinkText}>More stories</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
MostAnalytics.propTypes = {
  data: PropTypes.shape({
    path: PropTypes.string,
    items: PropTypes.arrayOf({}),
    name: PropTypes.string,
  }),
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
    prcValue: PropTypes.number,
  }),
  isWapView: PropTypes.bool,
};

MostAnalytics.defaultProps = {
  data: {},
  userData: undefined,
  isWapView: false,
};

export default MostAnalytics;
